// =============================================================================
// Supabase connection config (Phase 2). The publishable keys here are PUBLIC by
// design — they're meant to live in the browser bundle. The SECRET keys are NOT
// here and never ship. Which project the app talks to is resolved at runtime:
//   1. ?supabase=prod|staging  — explicit override for dev/testing
//   2. a real production kiosk hostname  -> prod
//   3. everything else (the staging worker, local dev)  -> staging
//
// Default is STAGING on purpose: during Phase 2, nothing should touch prod unless
// it's deliberately on a production kiosk domain at cut-over time. Mirrors the
// pattern getActiveSiteKey() already uses for per-site config.
// =============================================================================
export const SUPABASE = {
  staging: {
    url: "https://mnlcufhljvumllkupizg.supabase.co",
    anonKey: "sb_publishable_p9t_G6Qz0iC9aunnr3C90Q_vq1rDSs_",
  },
  prod: {
    url: "https://axqirfttzntuqgdzxegp.supabase.co",
    anonKey: "sb_publishable_VxUbgn8fIH30YseEsVIrBw_fPf2pMXb",
  },
};

// Only these production kiosk hostnames get the prod project.
const PROD_HOSTS = new Set([
  "trafford.eatrolled.com",
  "arndale.eatrolled.com",
  "mcr-kitchen.eatrolled.com",
  "meadowhall.eatrolled.com",
]);

export function getSupabaseEnvKey() {
  if (typeof window !== "undefined") {
    try {
      const q = new URLSearchParams(window.location.search).get("supabase");
      if (q === "prod" || q === "staging") return q;
    } catch (e) {}
    const host = (window.location.hostname || "").toLowerCase();
    if (PROD_HOSTS.has(host)) return "prod";
  }
  return "staging";
}

export function getSupabaseConfig() {
  return SUPABASE[getSupabaseEnvKey()];
}
